export const animationPreviewUrlBySlug: Record<string, string> = {
  "sparkle-pop":
    "https://assets-v2.lottiefiles.com/a/d11495f2-1177-11ee-b956-933b86b055db/C020as4J9V.lottie",
  "paw-confetti":
    "https://assets-v2.lottiefiles.com/a/76caddfc-116a-11ee-aa25-6333db7b8d8c/GpI0uQYnKa.lottie",
  "soft-pulse":
    "https://assets-v2.lottiefiles.com/a/bad23156-1153-11ee-abec-bfe5e65deaaf/IW8SPgxYfl.lottie",
  "comet-trail":
    "https://assets-v2.lottiefiles.com/a/75fe122c-1151-11ee-b2d7-8f6c65b950f5/4QrBJIYwKo.lottie",
  "aurora-wave":
    "https://assets-v2.lottiefiles.com/a/888a7040-1177-11ee-842f-034cc33f6d3d/eKfNrZYOZQ.lottie",
  "heartbeat-ring":
    "https://assets-v2.lottiefiles.com/a/9397d67a-1150-11ee-b84c-63325e245690/sE3fOzKcwB.lottie",
  "nova-burst":
    "https://assets-v2.lottiefiles.com/a/a9721aa6-1172-11ee-944c-a7256e4cbcac/A8cjjUnPGG.lottie",
  "galactic-ribbon":
    "https://assets-v2.lottiefiles.com/a/1635ed50-117a-11ee-a98c-374d4ecd591c/WS5HURZkay.lottie",
};

export const petImageUrlBySlug: Record<string, string> = {
  "clinic-cat": "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f431.svg",
  "paw-pup": "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f436.svg",
  "pocket-parrot":
    "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f99c.svg",
  "capy-care": "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f9ab.svg",
  "polar-fox": "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f98a.svg",
  "hedge-doc": "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f994.svg",
  "aurora-wolf": "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f43a.svg",
  "nebula-otter":
    "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f9a6.svg",
  "crimson-panda":
    "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f43c.svg",
  "celestial-jaguar":
    "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f406.svg",
  "phoenix-vet": "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f525.svg",
};

export const petAnimationUrlBySlug: Record<string, string> = {
  "clinic-cat":
    "https://assets-v2.lottiefiles.com/a/83627cee-1153-11ee-b832-fb1242dd7de9/sSzsHHquis.lottie",
  "paw-pup":
    "https://assets-v2.lottiefiles.com/a/a7463dc6-1153-11ee-8438-1bd7dc8f62ea/t25CmZT8xt.lottie",
  "pocket-parrot":
    "https://assets-v2.lottiefiles.com/a/4e7bf598-116f-11ee-9989-c78b961b5bbe/IpSMbBxXiN.lottie",
  "capy-care":
    "https://assets-v2.lottiefiles.com/a/00533084-0344-11f0-badc-db8e11723b5c/nnpBWx7QWE.lottie",
  "polar-fox":
    "https://assets-v2.lottiefiles.com/a/985f9bd6-0e4a-11f0-9ef6-f362a1ff0a9f/tfbImDLAsG.lottie",
  "hedge-doc":
    "https://assets-v2.lottiefiles.com/a/217fc672-1152-11ee-80ab-fb3529c2036a/9tlmySmhsS.lottie",
  "aurora-wolf":
    "https://assets-v2.lottiefiles.com/a/1427a6fc-5c61-11ee-ae6e-2baa03914b24/Aj04u0bGXM.lottie",
  "crimson-panda":
    "https://assets-v2.lottiefiles.com/a/068f1bec-1166-11ee-9994-df347a5320d0/DuuDVaJoKG.lottie",
  "celestial-jaguar":
    "https://assets-v2.lottiefiles.com/a/b7c19854-116b-11ee-a134-f3cdde3969db/cLpR7iGo7j.lottie",
  "phoenix-vet":
    "https://assets-v2.lottiefiles.com/a/c9471362-117d-11ee-9f06-d76a368bf2f8/FvoxJQ4UhP.lottie",
};
